import SessionStorageHandler from './SessionStorageHandler';

const sessionStorageHandler = new SessionStorageHandler();

export { sessionStorageHandler };
